"use client";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";
import type React from "react";

interface TermsConfirmDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isLoading?: boolean;
	/** カスタムメッセージ（指定しない場合はデフォルトメッセージを表示） */
	message?: React.ReactNode;
}

export function TermsConfirmDialog({
	open,
	onClose,
	onConfirm,
	isLoading = false,
	message,
}: TermsConfirmDialogProps): React.ReactElement {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>利用規約の更新確認</DialogTitle>
			<DialogContent>
				<Typography variant="body1" sx={{ mt: 2 }}>
					{message || (
						<>
							利用規約を更新しますか？
							<br />
							この操作により、現在の利用規約が新しいバージョンに更新されます。
							<br />
							更新後の編集や削除は出来ません。
						</>
					)}
				</Typography>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center", gap: 2, mb: 2 }}>
				<Button onClick={onClose} color="secondary" variant="contained">
					キャンセル
				</Button>
				<Button onClick={onConfirm} variant="contained" color="primary" disabled={isLoading}>
					{isLoading ? "更新中..." : "更新する"}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
